import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';

import { IconActionArrowRight16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';

interface IInfoLinkProps {
  url?: string | null;
  text?: string | null;
  onClick?(): void;
}

export function InfoLink({ url, text, onClick }: IInfoLinkProps) {
  if (!url || !text) {
    return null;
  }

  return (
    <a className={styles['link']} href={url} target="blank" rel="noreferrer" onClick={onClick}>
      <UIText1 as="span">{text}</UIText1>
      <div className={styles['arrow']}>
        <IconActionArrowRight16 color="icon-main-default" />
      </div>
    </a>
  );
}
